/**
 * Lazy-loaded component exports
 * These components are loaded on-demand to improve initial bundle size
 */

import * as React from 'react';

import { lazyLoad } from '../../utils/lazy-loading';

// Lazy load heavy components
export const LazyDataTable = lazyLoad(
  () =>
    import('../data-table').then((m) => ({ default: m.DataTable as React.ComponentType<unknown> })),
  {
    chunkName: 'DataTable',
    prefetch: true,
  }
);

export const LazyDataTableOptimized = lazyLoad(
  () =>
    import('../data-table-optimized').then((m) => ({
      default: m.DataTableOptimized as React.ComponentType<unknown>,
    })),
  {
    chunkName: 'DataTableOptimized',
    prefetch: true,
  }
);

// Complex form components
export const LazyFormWizard = lazyLoad(
  () =>
    import('../complex-forms/form-wizard').then((m) => ({
      default: m.FormWizard as React.ComponentType<unknown>,
    })),
  {
    chunkName: 'FormWizard',
  }
);

export const LazyDynamicFormArray = lazyLoad(
  () =>
    import('../complex-forms/dynamic-form-array').then((m) => ({
      default: m.DynamicFormArray as React.ComponentType<unknown>,
    })),
  {
    chunkName: 'DynamicFormArray',
  }
);

// File management
export const LazyImageViewer = lazyLoad(
  () =>
    import('../file-management/image-viewer').then((m) => ({
      default: m.ImageViewer as React.ComponentType<unknown>,
    })),
  {
    chunkName: 'ImageViewer',
  }
);

export const LazyPdfViewer = lazyLoad(
  () =>
    import('../file-management/pdf-viewer').then((m) => ({
      default: m.PdfViewer as React.ComponentType<unknown>,
    })),
  {
    chunkName: 'PdfViewer',
  }
);

export const LazyMultiFileUploader = lazyLoad(
  () =>
    import('../file-management/multi-file-uploader').then((m) => ({
      default: m.MultiFileUploader as React.ComponentType<unknown>,
    })),
  {
    chunkName: 'MultiFileUploader',
  }
);

// Activity components
export const LazyActivityFeed = lazyLoad(
  () =>
    import('../activity/activity-feed').then((m) => ({
      default: m.ActivityFeed as React.ComponentType<unknown>,
    })),
  {
    chunkName: 'ActivityFeed',
  }
);

export const LazyAuditTrail = lazyLoad(
  () =>
    import('../activity/audit-trail').then((m) => ({
      default: m.AuditTrail as React.ComponentType<unknown>,
    })),
  {
    chunkName: 'AuditTrail',
  }
);

// Timeline components
export const LazyTimeline = lazyLoad(
  () =>
    import('../timeline/timeline').then((m) => ({
      default: m.Timeline as React.ComponentType<unknown>,
    })),
  {
    chunkName: 'Timeline',
  }
);

export const LazyEventTimeline = lazyLoad(
  () =>
    import('../timeline/event-timeline').then((m) => ({
      default: m.EventTimeline as React.ComponentType<unknown>,
    })),
  {
    chunkName: 'EventTimeline',
  }
);

// Export lazy loading utilities
export {
  lazyLoad,
  lazyRoute,
  LazyLoadOnView,
  preloadComponent,
  preloadComponents,
  usePrefetch,
} from '../../utils/lazy-loading';
